export const CERTIFICATES = [{
    html: `<!DOCTYPE html>
    <html lang="en">
       <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Certificate of Achievement</title>
          <link rel="preconnect" href="https://fonts.googleapis.com" crossorigin="anonymous">
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="anonymous">
          <link href="https://fonts.googleapis.com/css2?family=Mr+De+Haviland&display=swap" rel="stylesheet" crossorigin="anonymous">

          <link href="https://fonts.googleapis.com/css2?family=Triodion&display=swap" rel="stylesheet"
             crossorigin="anonymous">
          <link href="https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap" rel="stylesheet" crossorigin="anonymous">
          <style>
             :root {
             --color-primary: #002855;
             --color-secondary: #aa8e39;
             --color-background: #fcfbfb;
             --color-text: #333333;
             --color-white: #ffffff;
             --color-black: #000000;
             --color-corner-border: gold;
             --color-border: #f3d782;
             }
             * {
             padding: 0;
             margin: 0;
             box-sizing: border-box;
             }
             body {
             font-family: "Triodion", serif;
             background-color: var(--color-background);
             display: flex;
             justify-content: center;
             align-items: center;
             }
             .corner-top-right, .corner-top-right-gold {
                  position: fixed;
                  top: -42px;
                  right: -19px;
                  width: 0;
                  height: 0;
                  border-style: solid;
                  border-width: 0 353px 300px 0;
                  border-color: transparent #002855 transparent transparent;
                  transform: rotate(-11deg);
            }
            .corner-top-right-gold {
                  border-color: transparent var(--color-corner-border) transparent transparent;
                  border-width: 0 384px 331px 0;
            }
            .corner-bottom-left, .corner-bottom-left-gold {
                  position: fixed;
                  bottom: -41px;
                  left: -33px;
                  width: 0;
                  height: 0;
                  border-style: solid;
                  border-width: 0 353px 300px 0;
                  border-color: transparent #002855 transparent transparent;
                  transform: rotate(169deg);
                  }
            .corner-bottom-left-gold {
                  border-color: transparent var(--color-corner-border) transparent transparent;
                  border-width: 0 384px 331px 0;
            }

             .mr-de-haviland-regular {
                font-family: "Mr De Haviland", serif;
                font-weight: 400;
                font-style: normal;
              }
             .certificate {
             padding: 2.5rem;
             
             /* border-radius: 0.625rem; */
             background-color: var(--color-white);
             text-align: center;
             box-shadow: 0 0.25rem 0.625rem rgba(0, 0, 0, 0.1);
             position: relative;
             }
             .certificate-header h1 {
             font-size: 6rem;
             margin: 0;
             letter-spacing: 0.4rem;
             color: var(--color-primary);
             }
             .certificate-header h2 {
             font-size: 3rem;
             margin: 0rem 0 2rem;
             color: var(--color-primary);
             }
             .present-to {
             font-size: 1.8rem;
             font-weight: bold;
             margin: 1.25rem 0;
             /* 20px / 16 = 1.25rem */
             color: var(--color-secondary);
             letter-spacing: 0.1rem;
             }
             .recipient-name {
             font-size: 6rem;
             font-family: "Great Vibes", serif;
             color: var(--color-primary);
             font-weight: 400;
             margin: 0.7rem 0;
             }
             .message {
             font-size: 1.6rem;
             margin: 1.25rem 0 2.5rem;
             /* 20px / 16 = 1.25rem, 40px / 16 = 2.5rem */
             color: var(--color-text);
             font-weight: 600;
             letter-spacing: 0.1rem;
             padding: 0 3rem;
             }
             .signatures {
             display: flex;
             justify-content: space-around;
             margin-top: 2.5rem;
             /* 40px / 16 = 2.5rem */
             position: relative;
             }
             .sign p {
             font-size: 2.6rem;
             margin: 1.25rem 0 2.5rem;
             /* 20px / 16 = 1.25rem, 40px / 16 = 2.5rem */
             color: var(--color-text);
             font-weight: 600;
             letter-spacing: 0.1rem;
             padding: 0 3rem;
             position: relative;
             }
             .sign p::after {
             content: "";
             top: 3rem;
             left: 0;
             height: 0.2rem;
             width: 100%;
             background-color: var(--color-black);
             position: absolute;
             }
             .badge-1 {
             position: absolute;
             left: 1rem;
             top: 1rem;
             width: 6rem;
             height: 6rem;
             }
             .badge-2 {
             position: absolute;
             right: 1rem;
             top: 1rem;
             width: 6rem;
             height: 6rem;
             }
             .badge {
             width: 100%;
             height: auto;
             }
             .certificate-body {
               padding: 3rem;
                width: 100%;
                height: 100%;
             }
             body {
                width: 100%;
                height: 100%;
             }
             .certificate-border {
                  border: 0.2rem solid var(--color-border);
             }
          </style>
          <script>
    
          </script>
       </head>
       <body>

    <div class="corner-top-right-gold"></div>
    <div class="corner-top-right"></div>
    <div class="corner-bottom-left-gold"></div>
    <div class="corner-bottom-left"></div>
          <div class="certificate-body">
             <div class="certificate">
               <div class="certificate-border">
                  <div class="badge-1">
                     <img src="https://cdn.makemybrand.ai/template-images/cert1/badge.png" alt="" class="badge">
                  </div>
                  <div class="badge-2">
                     <img src="https://cdn.makemybrand.ai/template-images/cert1/badge.png" alt="" class="badge">
                  </div>
                  <div class="certificate-header">
                     <h1>CERTIFICATE</h1>
                     <h2>OF ACHIEVEMENT</h2>
                  </div>
                  <p class="present-to">THIS CERTIFICATE IS PRESENTED TO</p>
                  <h1 class="recipient-name">{name}</h1>
                  <div>On</div>
                  <div>{date}</div>
                  <p class="message">
                     {description}
                  </p>
                  <div class="signatures">
                     <div class="sign-1 sign mr-de-haviland-regular">
                        <p>{signature}</p>
                     </div>
                  </div>
               </div>
            </div>
          </div>
       </body>
    </html>`,
preview: 'https://cdn.makemybrand.ai//tmp/fc564360/0.png'
}
]